import { Button, type ButtonProps, styled } from '@mui/material';

import { removeTheseProps } from '@/utils';

const HOVER_IS_ACTIVE_BACKGROUND_COLOR = 'rgba(255,255,255, 0.3)';

export type LinkStyledButtonProps = ButtonProps & {
  isActive: boolean;
};

export const LinkStyledButton = styled(Button, {
  shouldForwardProp: removeTheseProps<LinkStyledButtonProps>('isActive'),
})<LinkStyledButtonProps>(({ isActive, theme }) => ({
  width: '100%',
  height: 46,
  paddingTop: 8,
  paddingBottom: 8,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 9,
  cursor: 'pointer',
  ':hover': {
    backgroundColor: HOVER_IS_ACTIVE_BACKGROUND_COLOR,
    boxShadow: isActive
      ? `2px 0 0 ${theme.palette.horizonGreen.main} inset`
      : 'unset',
  },
  transition: '200ms',
  boxShadow: isActive
    ? `2px 0 0 ${theme.palette.horizonGreen.main} inset`
    : 'unset',
  backgroundColor: isActive ? HOVER_IS_ACTIVE_BACKGROUND_COLOR : 'unset',
  borderRadius: 0,
}));
